import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63ee2f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "analysis-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OperateHeader = _resolveComponent("OperateHeader")!
  const _component_ListTable = _resolveComponent("ListTable")!
  const _component_TabPane = _resolveComponent("TabPane")!
  const _component_ListChart = _resolveComponent("ListChart")!
  const _component_singleStationChart = _resolveComponent("singleStationChart")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_downloadModal = _resolveComponent("downloadModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OperateHeader, {
      "active-tab": _ctx.activeTab,
      onChangeStationType: _ctx.changeStationType,
      onGetListData: _ctx.getListData,
      onHandleDownload: _ctx.handleDownload,
      onDownloadChart: _ctx.downloadChart,
      onSetParams: _ctx.setParams,
      onSetTableType: _ctx.setTableType
    }, null, 8, ["active-tab", "onChangeStationType", "onGetListData", "onHandleDownload", "onDownloadChart", "onSetParams", "onSetTableType"]),
    _createVNode(_component_Tabs, {
      activeKey: _ctx.activeTab,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      type: "card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPane, {
          key: "1",
          tab: "列表"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ListTable, {
              "time-format": _ctx.paramFormat,
              "param-type": _ctx.param,
              "list-data": _ctx.listData,
              "table-type": _ctx.tableType
            }, null, 8, ["time-format", "param-type", "list-data", "table-type"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPane, {
          key: "2",
          tab: "图表"
        }, {
          default: _withCtx(() => [
            (_ctx.tableType ===1)
              ? (_openBlock(), _createBlock(_component_ListChart, {
                  key: 0,
                  "air-type": _ctx.param,
                  "time-format": _ctx.paramFormat,
                  "list-data": _ctx.listData,
                  "is-download-chart": _ctx.isDownloadChart,
                  onHadDownloadChart: _ctx.hadDownloadChart
                }, null, 8, ["air-type", "time-format", "list-data", "is-download-chart", "onHadDownloadChart"]))
              : (_openBlock(), _createBlock(_component_singleStationChart, {
                  key: 1,
                  airType: "co",
                  standardDataList: _ctx.listData
                }, null, 8, ["standardDataList"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(_component_downloadModal, {
      "download-visible": _ctx.downloadVisible,
      "station-list": _ctx.stationList,
      stations: _ctx.stations,
      onCancal: _ctx.cancal,
      onSave: _ctx.save
    }, null, 8, ["download-visible", "station-list", "stations", "onCancal", "onSave"])
  ]))
}